<!-- @veltra/icons generated sha256:9a26ebe47e7ebcaf gen:8 source:src/svg/normal/tools.svg -->
<script setup lang="ts">
defineOptions({ name: 'Tools' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="m9.75 8.25.562.154a2.91 2.91 0 0 0 2.846-.733 2.9 2.9 0 0 0 .807-2.505L12.91 6.223a1.5 1.5 0 0 1-2.121 0l-.425-.425a1.5 1.5 0 0 1 0-2.121l1.057-1.056a2.9 2.9 0 0 0-2.505.807 2.91 2.91 0 0 0-.733 2.846l.154.561-5.804 5.805 1.414 1.414zm2.494-6.454q.213.072.419.169c.285.133.313.513.09.736L11.07 4.384a.5.5 0 0 0 0 .707l.425.425a.5.5 0 0 0 .707 0l1.683-1.683c.223-.223.603-.195.736.09q.097.206.168.42c.466 1.38.16 2.95-.924 4.035a3.91 3.91 0 0 1-3.819.99l-5.393 5.393a1 1 0 0 1-1.414 0l-1.414-1.414a1 1 0 0 1 0-1.415L7.218 6.54a3.91 3.91 0 0 1 .99-3.82c1.084-1.083 2.656-1.39 4.036-.924"
    />
  </svg>
</template>
